import { TextField, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled TextField
export const StyledAutoCompleteTextField = styled(TextField)(({ theme }) => ({
  height: '100%',

  '& .MuiInputBase-root': {
    backgroundColor: 'transparent',
    fontSize: theme.typography.pxToRem(14),
    height: '100%',
    borderWidth: 0,
    paddingRight: '0 !important',
    '& .MuiInputBase-input, & .MuiInput-input': {
      fontSize: theme.spacing(2),
      padding: `${theme.spacing(1.625, 3, 1.125, 0)} !important`,
      '&::placeholder': {
        color: theme.palette.common.white,
        opacity: 1,
      },
    },

    '&::before, &::after': {
      borderColor: 'transparent !important',
    },
  },
  '& .MuiInputAdornment-root': {
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(0.5),
    cursor: 'pointer',
    transition: 'transform 0.2s',
    [theme.breakpoints.down('xl')]: {
      marginLeft: theme.spacing(1.25),
    },
    '& svg': {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
    },
    '&.open svg': {
      transform: 'rotate(180deg)',
    },
  },
  '& .MuiAutocomplete-clearIndicator ': {
    right: theme.spacing(0.5),
  },
}));

// Styled Paper for dropdown menu
export const StyledAutoCompletePaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider[7]}`,
  background: theme.palette.secondary.dark,
  backdropFilter: `blur(${theme.spacing(1)})`,
  color: theme.palette.common.white,
  fontSize: theme.spacing(2),
  padding: theme.spacing(0.5, 0, 0.5, 0.5),

  // listbox scroll
  '& .MuiAutocomplete-listbox': {
    maxHeight: theme.spacing(38),
    overflowY: 'auto',

    /* Scrollbar Styles */
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.spacing(1),
      border: '2px solid transparent',
      backgroundClip: 'content-box',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.grey[500],
    },
  },

  '& .MuiAutocomplete-option': {
    padding: `${theme.spacing(1.5, 1.75)} !important`,
    marginRight: theme.spacing(0.5),
    minHeight: 'unset',
    // Apply same style on hover, focus, active, and selected
    '&:hover, &.Mui-focused, &.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: `${theme.palette.action.hover} !important`,
      border: `1px solid ${theme.palette.text.secondary}`,
      borderRadius: theme.spacing(0.5),
    },
    '& .FAOptionText': {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      lineHeight: theme.spacing(2),
    },
  },
}));
